import withMention from './plugin.js';
import renderElemConf from './render-elem.js';
import elemToHtmlConf from './elem-to-html.js';
import parseHtmlConf from './parse-elem-html.js';
import AIMenu from './ai-menu.js';

import { Boot } from '@wangeditor/editor';

const module = {
  // JS 语法
  editorPlugin: withMention,
  renderElems: [renderElemConf],
  elemsToHtml: [elemToHtmlConf],
  parseElemsHtml: [parseHtmlConf],
  menus: [
    {
      key: 'aiMenu',
      factory() {
        return new AIMenu();
      }
    }
  ]
};

let registered = false;

export default function registerModule() {
  if (registered) return;
  registered = true;
  Boot.registerModule(module);
}
